import type { BaseApiError } from '@lumapps/base-api';
import { logException } from '@lumapps/base-api/utils/logException';
import type { Dispatch, GetFrontOfficeState } from '@lumapps/redux/types';

import { FetchBlockParams, getWidgetBlocksByProperties } from '../../api';
import { LegacyWidget } from '../../types';
import { getFormattedWidgetFilterFetchParams } from '../../utils/getFormattedWidgetFilterFetchParams';
import { fetchWidgetBlocks } from './fetchWidgetBlocks';

export const fetchWidgetBlocksByProperties =
    ({
        params: { ownerResourceInfo, ...params } = {},
        legacyWidget,
        isMainWidget,
        skipErrorHandling,
    }: {
        params?: FetchBlockParams;
        legacyWidget: LegacyWidget;
        isMainWidget?: boolean;
        // This param is to let the query handle the error instead of the redux state
        skipErrorHandling?: boolean;
    }) =>
    (dispatch: Dispatch, getState: GetFrontOfficeState) => {
        const { uuid: widgetId, widgetType } = legacyWidget;
        const currentState = getState();
        const filterFetchParams = getFormattedWidgetFilterFetchParams(currentState, params, widgetId);
        const fetchParams = { ...params, ...filterFetchParams };

        return dispatch(
            fetchWidgetBlocks(
                widgetId,
                (acceptLanguageHeader) =>
                    getWidgetBlocksByProperties(legacyWidget, fetchParams, acceptLanguageHeader, ownerResourceInfo),
                fetchParams,
                isMainWidget,
                widgetType,
                skipErrorHandling,
                legacyWidget,
            ),
        ).catch((exception: BaseApiError) => {
            logException(exception);
            throw new Error(exception.message);
        });
    };
